import { Outlet } from "react-router-dom";

import { PageHeader } from "src/components/pageHeader";
import { VFlex } from "src/components/vFlex";

import { getUserAndBotTabs } from "./constants";

import "./userAndBotLayout.scss";

/**
 * Shared layout component for User and Bot Management pages
 * Provides consistent header with tabs across both pages
 * Uses React Router's Outlet to render child routes
 */
export const UserAndBotLayout = () => {
  const tabs = getUserAndBotTabs();

  return (
    <VFlex className="cnc-user-bot-management">
      <PageHeader
        actions={[]}
        name="userAndBotManagement"
        title="User and bot management"
        tabs={tabs}
      />
      <Outlet />
    </VFlex>
  );
};
